module.exports = __webpack_public_path__ + "img/pic_1.0b4e8b29.png";